import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import useFormatter from '../../common/useFormatter';
import * as Icon from '../../components/icons';
import { getItemSetMetricDescriptorsMap } from './itemSetMetric.default';
import { ItemSetMetricDescriptor } from './itemSetMetric.types';

function useItemSetMetricDescriptorsMap() {
  const { t } = useTranslation('app');
  const formatter = useFormatter();
  // const extraDescriptors = useRecoilValue(actualityExtraMetricDescriptors);

  const metrics: ItemSetMetricDescriptor[] = [
    // ITEMS METRICS
    {
      ...getItemSetMetricDescriptorsMap(t).consigneeSku,
      category: 'item',
      titleCategory: t('Item', { ns: 'dataset' }),
      title: t('Item (SKU)', { ns: 'dataset' }),
      subTitle: t('Item', { ns: 'dataset' }),
      actionTitle: t('show sku', { ns: 'dataset' }),
      icon: Icon.CongestionMap4,
    },
    {
      ...getItemSetMetricDescriptorsMap(t).consignee,
      category: 'item',
      titleCategory: t('Item', { ns: 'dataset' }),
      title: t('Consignee', { ns: 'dataset' }),
      subTitle: t('Item', { ns: 'dataset' }),
      actionTitle: t('show consignee', { ns: 'dataset' }),
      icon: Icon.CongestionMap4,
    },
    {
      ...getItemSetMetricDescriptorsMap(t).skuGroup,
      category: 'item',
      titleCategory: t('Item', { ns: 'dataset' }),
      title: t('Item Group', { ns: 'dataset' }),
      subTitle: t('Item', { ns: 'dataset' }),
      actionTitle: t('show Item (SKU) Group', { ns: 'dataset' }),
      icon: Icon.CongestionMap4,
    },
    {
      ...getItemSetMetricDescriptorsMap(t).subGroup,
      category: 'item',
      titleCategory: t('Item', { ns: 'dataset' }),
      title: t('Sub Group', { ns: 'dataset' }),
      subTitle: t('Item', { ns: 'dataset' }),
      actionTitle: t('show Sub Group', { ns: 'dataset' }),
      icon: Icon.CongestionMap4,
    },

    {
      ...getItemSetMetricDescriptorsMap(t).stockCategory,
      category: 'item',
      titleCategory: t('Item', { ns: 'dataset' }),
      title: t('Stock Category', { ns: 'dataset' }),
      subTitle: t('Stock Category', { ns: 'dataset' }),
      actionTitle: t('show tStock Category', { ns: 'dataset' }),
      icon: Icon.CongestionMap4,
    },
    {
      ...getItemSetMetricDescriptorsMap(t).transportClass,
      category: 'item',
      titleCategory: t('Item', { ns: 'dataset' }),
      title: t('Transport Class', { ns: 'dataset' }),
      subTitle: t('Transport Class', { ns: 'dataset' }),
      actionTitle: t('show Transport Class', { ns: 'dataset' }),
      icon: Icon.CongestionMap4,
    },
    {
      ...getItemSetMetricDescriptorsMap(t).storageClass,
      category: 'item',
      titleCategory: t('Item', { ns: 'dataset' }),
      title: t('Storage Class', { ns: 'dataset' }),
      subTitle: t('Storage Class', { ns: 'dataset' }),
      actionTitle: t('show Storage Class', { ns: 'dataset' }),
      icon: Icon.CongestionMap4,
    },
    {
      ...getItemSetMetricDescriptorsMap(t).pollutionClass,
      category: 'item',
      titleCategory: t('Item', { ns: 'dataset' }),
      title: t('Pollution Class', { ns: 'dataset' }),
      subTitle: t('Pollution Class', { ns: 'dataset' }),
      actionTitle: t('show pollution class', { ns: 'dataset' }),
      icon: Icon.CongestionMap4,
    },

    // Item UOM METRICS
    {
      ...getItemSetMetricDescriptorsMap(t).uom,
      category: 'itemUom',
      titleCategory: t('Item (UOM)', { ns: 'dataset' }),
      title: t('UOM Type', { ns: 'dataset' }),
      subTitle: t('Item', { ns: 'dataset' }),
      icon: Icon.CongestionMap4,
    },
    {
      ...getItemSetMetricDescriptorsMap(t).uomWeight,
      category: 'itemUom',
      titleCategory: t('Item (UOM)', { ns: 'dataset' }),
      title: t('UOM Weight', { ns: 'dataset' }),
      subTitle: t('Item', { ns: 'dataset' }),
      format: v => formatter.formatWeight(v, 10).fullString,
      icon: Icon.CongestionMap4,
    },
    {
      ...getItemSetMetricDescriptorsMap(t).uomWeightPow,
      category: 'itemUom',
      titleCategory: t('Item (UOM)', { ns: 'dataset' }),
      title: t('UOM Weight (Distinct)', { ns: 'dataset' }),
      subTitle: t('Item', { ns: 'dataset' }),
      format: v => formatter.formatWeight(v, 10).fullString,
      icon: Icon.CongestionMap4,
    },
    {
      ...getItemSetMetricDescriptorsMap(t).uomVolume,
      category: 'itemUom',
      titleCategory: t('Item (UOM)', { ns: 'dataset' }),
      title: t('UOM Volume', { ns: 'dataset' }),
      subTitle: t('Item', { ns: 'dataset' }),
      format: v => formatter.formatVolume(v).fullString,
      icon: Icon.CongestionMap4,
    },
    {
      ...getItemSetMetricDescriptorsMap(t).uomMaxStack,
      category: 'itemUom',
      titleCategory: t('Item (UOM)', { ns: 'dataset' }),
      title: t('Max Stackability', { ns: 'dataset' }),
      subTitle: t('Item', { ns: 'dataset' }),
      icon: Icon.CongestionMap4,
    },
    // ...(extraDescriptors as any),
  ];

  return _.keyBy(metrics, d => d.type);
}

export default useItemSetMetricDescriptorsMap;
